<template lang="pug">
//- 精緻團班
.course-in-index.page-index
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
  .row.course-in-content(v-if="show_page")
    .course-in-content-left.padding-right-none
      .course-in-main
        .course-in-title
          .title {{ course.course_name }}
          .text 上課時間: {{ course.course_regtime }}
        .course-bgimg
          img(
            v-if="course.course_lang === 'en'",
            src="@/assets/images/e-01@3x.png"
          )
          img(
            v-if="course.course_lang === 'ja'",
            src="@/assets/images/j-01@3x.png"
          )
          img(
            v-if="course.course_lang === 'ko'",
            src="@/assets/images/k-01@3x.png"
          )
    .course-in-content-right.padding-none
      .right-top
        //- 等待搶課
        .course-status-box(v-if="course.course_status === 1")
          img.status-img(src="@/assets/images/course-1.png")
          .status-text
            span.status-1 等待搶課
          .clearfix
        //- 等待排課
        .course-status-box(v-if="course.course_status === 2")
          img.status-img(src="@/assets/images/course-2.png")
          .status-text
            span.status-2 等待排課
          .clearfix
        //- 等待上課
        .course-status-box(
          v-if="course.course_status === 3 && course.type_now_status === 1"
        )
          img.status-img(src="@/assets/images/course-3.png")
          .status-text
            span.status-3 等待上課
          .clearfix
        //- 正在上課
        .course-status-box(
          v-if="course.course_status === 3 && course.type_now_status === 2"
        )
          img.status-img(src="@/assets/images/course-3.png")
          .status-text
            span.status-3 正在上課
          .clearfix
        //- 上課完成
        .course-status-box(v-if="course.course_status === 4")
          img.status-img(src="@/assets/images/course-4.png")
          .status-text
            span.status-4 上課完成
          .clearfix
        //- 等待取消
        .course-status-box(v-if="course.course_status === 5")
          img.status-img(src="@/assets/images/course-5.png")
          .status-text
            span.status-5 等待取消
          .clearfix
        //- 課程取消
        .course-status-box(v-if="course.course_status === 5")
          img.status-img(src="@/assets/images/course-5.png")
          .status-text
            span.status-5 課程取消
          .clearfix

        .course-buttons(v-if="!course.is_expired")
          //- 進入互動課程按鈕
          .enter-button.enter-button-o(
            v-if="course.order_meeting",
            @click="goMeet(course.course_id)"
          ) 互動課程

          //- 預約課堂鈕
          .enter-button.enter-button-o(
            v-else-if="(course.is_started || $root.setting.mp_course.open_register === 'Y') && !course.course_record",
            @click="clickOption(course, 'inter')"
          ) 互動課程

          //- 進入直播課程按鈕
          .enter-button.enter-button-g(
            v-if="course.is_started && course.order_live && course.have_live",
            @click="goLive(course.course_id)"
          ) 直播課程

          //- 取消預約按鈕
          .enter-button.enter-button-g(
            v-if="course.is_started && !course.order_live && course.have_live",
            @click="clickOption(course, 'live')"
          ) 直播課程

      //- 課程資訊
      .course-info-box
        //- 課程title
        .course-title {{ course.course_name }}

        //- 課程類別
        .course-group-50
          .course-sm-title 類別
          .course-sm-content 
            span(
              v-for="course_type in $root.total_course",
              v-if="course.course_classtype === course_type.id"
            ) {{ course_type.name }}

        //- 課程語言
        .course-group-50
          .course-sm-title 語言
          .course-sm-content(v-if="course.course_lang === 'en'") 美語
          .course-sm-content(v-if="course.course_lang === 'ja'") 日語
          .course-sm-content(v-if="course.course_lang === 'ko'") 韓語
        .clearfix

        //- 課程點數
        .course-group-50(v-if="course.course_point")
          .course-sm-title 互動課程點數
          .course-sm-content {{ course.course_point }}點

        //- 課程點數
        .course-group-50
          .course-sm-title 直播課程點數
          .course-sm-content {{ course.course_live_point }}點
        .clearfix

        //- 課程時間
        .course-group-50
          .course-sm-title 上課時間
          .course-sm-content {{ course.course_regtime }}
        //- 課程總長
        .course-group-50
          .course-sm-title 課程總長
          .course-sm-content {{ course.course_minutes }}min
        .clearfix

        //- 課程進度
        .course-group-50
          .course-sm-title 課程進度
          .course-sm-content 課程進度
        //- 目前人數
        .course-group-50
          .course-sm-title 目前人數
          .course-sm-content {{ course.course_student_use }} / {{ course.course_student_max }}
        .clearfix

        //- 課程描述
        .course-group-100
          .course-sm-title 課程描述
          .course-sm-content {{ course.course_directions }}

        //- 授課教師
        .course-group-100
          .course-sm-title 授課教師
          .teacher-btn.btn.bg-blue-1 {{ course.teacher_info.name }}
          //- 禮物按鈕
          //- .gift-imgbox(@click="$root.openGift()")
            img.gift-img(src="@/assets/images/gift.png")
          //- 讚 按鈕
          //- .good-imgbox(@click="clickGoodBtn()")
            img.good-img(
              v-if="!course.good_status",
              src="@/assets/images/good-gray.png"
            )
            img.good-img.animated-3.zoomIn(
              v-else,
              src="@/assets/images/good-blue.png"
            )
          .clearfix

        //- 教材預覽
        //- .textbook-box
          img.text-book-img(src="@/assets/images/textbook.png")
          .textbook-content
            .textbook-title 教材預覽
            //- .textbook-textbox
              .textbook-text(v-if="!course.textbook_status") 教材尚未開放
              .textbook-text(v-else) 教材已開放預覽
            //- .textbook-btnbox
              .textbook-btn.btn.bg-gray-2(v-if="!course.textbook_status") 尚未開放
              .textbook-btn.btn.bg-orange(v-else) 前往預覽
            .textbook-textbox
              .textbook-text 教材尚未開放
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
export default {
  coures_teacher: {
    name: 'CourseIn',
  },
  components: {
    ContentTop,
  },
  data () {
    return {
      course_id: false,
      show_page: false,
      course: {
        lan: 'ja',
        title: '日語初級1（B)',
        class: '日語課程教材',
        point: 4,
        star_time: '2021-03-10 13:30',
        total_time: 90,
        teacher: '中川陽介',
        good_status: false,
        description: '日語（基礎、初級1）循環',
        course_status: 1,
        textbook_status: true,
        can_enter_status: false,
        order_success: false
      }
    };
  },
  async created () {
    // 獲取需要處理的課程ID
    this.course_id = this.$route.params.course_id
    // 獲取課程細節資料
    this.getCourseDetail(this.course_id)
  },
  mounted () {
  },
  watch: {

  },
  computed: {
  },
  methods: {
    // 請求獲取課程資料
    async getCourseDetail () {
      // 開啟載入中
      this.$root.useLoading()
      // 獲得課程清單
      await this.$root.apis.getCourseDetail(this.course_id, 'course', this.processCourseDetailSuccess, this.processCourseDetailError)
      // 開啟課程內頁
      this.show_page = true
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理回傳成功的課程資料
    processCourseDetailSuccess (_response) {
      if (_response.body.error_code !== 0) {
        return this.processCourseDetailError(_response)
      }

      // 處理獲得的課程資料
      let course = _response.body.data

      // 確認是否可以購買
      course.can_enter_status = false

      // 獲取課程資料
      this.course = course

      // 若已過期就跳 Alert
      if (this.course.is_expired) {
        this.$root.openOptionView({
          title: "過期的課程",
          text_1: "這堂課程目前已經下課囉！",
          text_2: '',
          course_text: '',
          option_1: "瞭解",
          option_2: "",
          option_1_fun: false,
          option_2_fun: false
        })
      }
    },
    // 處理回傳失敗的課程資料
    processCourseDetailError () {

    },
    // 開啟會議室
    startOpenMeeting () {
      this.$root.openMeeting(this.course_id)
    },
    // 開啟直播間
    startOpenLiveView () {
      this.$root.openLiveView(this.course_id)
    },
    // 當用戶點擊課程按鈕
    clickOption (_course, _type) {
      console.log(_course)
      // 紀錄目前操作的課程ID
      this.course_id = _course.course_id
      this.process_course = _course
      // 請求互動課程
      if (_type === 'inter') {

        // 未開放互動課程
        if (!_course.have_inter) {
          this.$root.openOptionView({
            title: "未開放互動的課程",
            text_1: "這堂課程目前不開放互動教室",
            text_2: '',
            course_text: '',
            option_1: "確認",
            option_2: "",
            option_1_fun: false,
            option_2_fun: false
          })
          return
        }

        // 是否已經購買過課程
        if (_course.order_meeting) {
          this.registerCourse()
          return
        }

        // 人數已滿
        if (_course.course_student_use >= _course.course_student_max) {
          this.$root.openOptionView({
            title: "目前人數額滿",
            text_1: "您選擇的課程目前額滿",
            text_2: '',
            course_text: '',
            option_1: "確認",
            option_2: "",
            option_1_fun: false,
            option_2_fun: false
          })
          return
        }

        // 處理登記課程
        this.$root.openOptionView({
          title: "互動課程",
          text_1: "您選擇互動課程",
          text_2: '需要扣除 ' + this.$root.common.formatNumber(_course.course_point, 0) + ' 點數，確認進入教室？',
          course_text: _course.title,
          option_1: "確認",
          option_2: "我再考慮",
          option_1_fun: this.registerCourse,
          option_2_fun: false
        })
        return
      }

      // 請求直播課程
      else if (_type === 'live') {

        // 未開放直播課程
        if (!_course.have_live) {
          this.$root.openOptionView({
            title: "未開放直播的課程",
            text_1: "這堂課程目前不開放直播教室",
            text_2: '',
            course_text: '',
            option_1: "確認",
            option_2: "",
            option_1_fun: false,
            option_2_fun: false
          })
          return
        }

        // 是否已經購買過課程
        if (_course.order_live) {
          this.openCourseLive()
          return
        }

        // 處理登記直播
        this.$root.openOptionView({
          title: "直播課程",
          text_1: "您選擇直播課程",
          text_2: '需要扣除 ' + this.$root.common.formatNumber(_course.course_live_point, 0) + ' 點數，確認進入直播？',
          course_text: _course.title,
          option_1: "確認",
          option_2: "我再考慮",
          option_1_fun: this.openCourseLive,
          option_2_fun: false
        })
        return
      }

      // 發生未知的問題
      else {
        this.$root.openOptionView({
          title: "發生未知的問題",
          text_1: "很抱歉，目前功能發生障礙",
          text_2: '請稍後再試',
          course_text: '',
          option_1: "瞭解",
          option_2: "",
          option_1_fun: false,
          option_2_fun: false
        })
        return
      }
    },
    // 請求預約團體班課程
    async registerCourse () {
      // 開啟載入中
      this.$root.useLoading()
      // 向後端請求預約課程
      await this.$root.apis.registerGroupCourse(this.course_id, this.processRegCourseSuccess, this.processRegCourseError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理返回預約成功的資料
    processRegCourseSuccess (_response) {
      // 處理異常資料
      if (_response.body.error_code !== 0 && _response.body.error_code !== 3001) {
        return this.processRegCourseError(_response)
      }

      // 更新課程資料
      this.getCourseDetail(this.course_id)

      // 進入會議室
      if (this.process_course.is_started) {
        this.$root.common.goMeet(0, this.course_id)
      }

      // 告知學員已經預約成功
      else {
        this.$root.openOptionView({
          title: "預約成功",
          text_1: '課程已經預約成功',
          text_2: '請在課程開始時進入會議室哦！',
          course_text: '',
          option_1: "瞭解",
          option_2: '',
          option_1_fun: false,
          option_2_fun: false
        })
      }
    },
    // 處理返回預約失敗的資料
    processRegCourseError (_error) {
      this.$root.openOptionView({
        title: "扣點失敗",
        text_1: _error.body.message,
        text_2: '',
        course_text: '',
        option_1: "瞭解",
        option_2: '',
        option_1_fun: false,
        option_2_fun: false
      })
    },
    // 請求進入課程直播
    async openCourseLive () {
      // 開啟載入中
      this.$root.useLoading()
      // 向後端請求進入課程直播
      await this.$root.apis.liveGroupCourse(this.course_id, this.processLiveCourseSuccess, this.processLiveCourseError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理返回直播請求成功的資料
    processLiveCourseSuccess (_response) {
      // 處理異常資料
      if (_response.body.error_code !== 0 && _response.body.error_code !== 3001) {
        return this.processRegCourseError(_response)
      }

      // 更新課程資料
      this.getCourseDetail(this.course_id)

      if (this.process_course.is_started) {
        // 進入直播間
        this.$root.common.goLive(this.course_id)
      } else {
        this.$root.openOptionView({
          title: "預約成功",
          text_1: '課程已經預約成功',
          text_2: '請在課程開始時進入直播間哦！',
          course_text: '',
          option_1: "瞭解",
          option_2: '',
          option_1_fun: false,
          option_2_fun: false
        })
      }
    },
    // 處理返回直播請求失敗的資料
    processLiveCourseError (_error) {
      this.$root.openOptionView({
        title: "發生問題",
        text_1: _error.body.message,
        text_2: '',
        course_text: '',
        option_1: "瞭解",
        option_2: '',
        option_1_fun: false,
        option_2_fun: false
      })
    },
    // 前往會議室
    goMeet (_courseID) {
      if (!this.course.is_started) {
        return this.$root.openOptionView({
          title: "尚未開始",
          text_1: '課程尚未開始哦！',
          text_2: '請在課程開始時進入會議室哦！',
          course_text: '',
          option_1: "瞭解",
          option_2: '',
          option_1_fun: false,
          option_2_fun: false
        })
      }
      this.$root.common.goMeet(0, _courseID)
    },
    // 前往直播
    goLive (_courseID) {
      if (!this.course.is_started) {
        return this.$root.openOptionView({
          title: "尚未開始",
          text_1: '課程尚未開始哦！',
          text_2: '請在課程開始時進入直播間哦！',
          course_text: '',
          option_1: "瞭解",
          option_2: '',
          option_1_fun: false,
          option_2_fun: false
        })
      }
      this.$root.common.goLive(_courseID)
    }
  }
}
</script>
<style lang="sass">
</style>
